import { Box, Typography } from '@mui/material';
import React from 'react';

import { DATA_TEST } from '../enums';

interface ICouterAdornmentProps {
  count: number;
}
export const CounterAdornment: React.FC<ICouterAdornmentProps> = ({ count }) => {
  return (
    <Box
      data-test={DATA_TEST.counter_adornment}
      sx={{
        display: 'flex',
        color: 'common.white',
        borderRadius: 1,
        backgroundColor: 'text.secondary',
        marginLeft: 0.5,
        px: 0.5,
        py: 0.125
      }}
    >
      <Typography variant="h5" component="span" noWrap={true} lineHeight="1rem">
        {count > 99 ? '99+' : count < 0 ? '0' : `${count}`}
      </Typography>
    </Box>
  );
};
